import { render, staticRenderFns } from "./WaSideMenuSection.vue?vue&type=template&id=4a5e8cc2"
import script from "./WaSideMenuSection.vue?vue&type=script&lang=js"
export * from "./WaSideMenuSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports